import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "Whats-new",
      "style": {
        "position": "relative"
      }
    }}>{`What's new`}</h2>
    <p>{`In our latest release on March 16, 2023, we made the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated `}<Link href="/fact-sheet" linkType="default" mdxType="Link">{`Monthly Fact Sheet`}</Link></li>
      <li parentName="ul">{`Added `}<Link href="/downloads/disbursements-by-month/" linkType="default" mdxType="Link">{`Monthly disbursements data`}</Link></li>
      <li parentName="ul">{`Added `}<Link href="/downloads/production-by-month/" linkType="default" mdxType="Link">{`Monthly production data`}</Link></li>
      <li parentName="ul">{`Added `}<Link href="/downloads/production-by-disposition/" linkType="default" mdxType="Link">{`Monthly production disposition data`}</Link></li>
      <li parentName="ul">{`Added `}<Link href="/downloads/revenue/" linkType="default" mdxType="Link">{`Monthly revenue data`}</Link></li>
      <li parentName="ul">{`Added `}<a parentName="li" {...{
          "href": "https://blog-nrrd.doi.gov/plain-language/"
        }}>{`a blog about implementing plain language on onrr.gov and coordinating with content owners`}</a></li>
    </ul>
    <p>{`Review our `}<a parentName="p" {...{
        "href": "https://github.com/ONRR/nrrd/releases"
      }}>{`full release details`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      